<template>
  <div>		
		<div class="pg-header">
			<div>
				<label class="title">无身份证患者</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<!-- <router-link to="/">患者管理</router-link>| -->
					<span>患者管理</span>|
					<span class="active">无身份证患者</span>
				</div>
				<a class="back noline" @click="goBack">返回</a>
			</div>
		</div>
		
		<div class="table-wrap">
			<div class="search-bar">
				<label>姓名
					<el-input size="small" placeholder="姓名" clearable v-model="filter.name" @keyup.enter.native="handleFilter(0)"></el-input>
				</label>
				<el-button size="mini" icon="el-icon-search" round @click="handleFilter(0)">搜索</el-button>
			</div>
			<el-table ref="multipleTable"  header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
				<el-table-column prop="name" label="姓名"></el-table-column>
				<el-table-column prop="sex" label="性别">
					<template slot-scope="scope">
						<span v-if="scope.row.sex === 1">男</span>
						<span v-else>女</span>
					</template>
				</el-table-column>
				<el-table-column prop="age" label="年龄">
					<template slot-scope="scope">
						<span>{{scope.row.age}} 岁</span>
					</template>
				</el-table-column>
				<el-table-column prop="nation" label="民族"></el-table-column>
				<el-table-column prop="phone" label="联系电话">
					<template slot-scope="scope">
						<span v-text="scope.row.phone == 'null'? '暂无电话' : scope.row.phone"></span>
					</template>
				</el-table-column>
				<el-table-column prop="date" label="更新时间" width="200"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<div class="tab-action">
							<el-tooltip content="补录" placement="top" :enterable="false"><i class="el-icon-edit-outline" @click="showDlg(scope.row)"></i></el-tooltip>
							<el-tooltip content="查看" placement="top" :enterable="false"><router-link target="_blank"  :to="{name: 'Patient/User', query: {patientId: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip>
							<!-- <el-popconfirm confirmButtonText='删除' title="确定删除吗？" @confirm="delItem(scope.row)">
								<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i class="el-icon-delete"></i></el-tooltip>
							</el-popconfirm> -->
						</div>
					</template>
				</el-table-column>
			</el-table>	

			<div class="pagination">
				<el-row>
					<el-col :span="12">
						<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
						<div class="record">总计<span v-text="list.total"></span>条记录</div>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>

		<el-dialog title="补录身份证" width="560px" center :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item label="身份证号码" prop="cardNum">
					<el-input autocomplete="off" maxlength="18" :show-word-limit="true" v-model="form.cardNum"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="saveForm1">提 交</el-button>
			</div>
		</el-dialog>
		
		<el-dialog title="确认合并患者" width="560px" center :visible.sync="dlg.active2" :close-on-click-modal="false">
			<div style="margin-bottom: 5px; text-align: center;color: #f56c6c;">补录身份证号码：{{ form.cardNum }} 与已有患者重复</div>
			<div style="margin-bottom: 20px; text-align: center;">请联系系统管理员处理</div>

			<el-table header-cell-class-name="tab-cell" cell-class-name="tab-cell" :data="list2.data" v-loading="isLoading" @selection-change="onPatientSelection" :row-class-name="tableRowClassName">
				<!-- <el-table-column fixed="left" type="selection" width="40"></el-table-column> -->
				<el-table-column label="状态" width="100">
					<template slot-scope="scope">
						<span v-if="scope.$index === 0">当前患者</span>
						<span v-else>重复患者</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="姓名" width="100"></el-table-column>
				<el-table-column prop="cardNum" label="身份证号码"></el-table-column>
				<el-table-column align="center" label="操作" width="60">
					<template slot-scope="scope">
						<div class="tab-action">
							<el-tooltip content="查看" placement="top" :enterable="false"><router-link target="_blank"  :to="{name: 'Patient/User', query: {patientId: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
				<!-- <el-button type="primary" :loading="isLoading" @click="saveForm2">提 交</el-button> -->
			</div>
		</el-dialog>
		

  </div>
	
			
</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import idValidator from 'id-validator';
import dayjs from 'dayjs';


const Validator = new idValidator();
export default {
	mixins: [mixin],
	data(){
		const cardNumValidator = (rule, value, callback)=>{
			if (value === '') {
				callback(new Error('请输入身份证号码'));
			} else {
				// console.log('没走吧');
				if (!Validator.isValid(value)) {
					callback(new Error('身份证号码无效'));
				}
				callback();
			}			
		};
		return {
			dlg: {
				active: false,
				active2: false,
				rules: {
					cardNum: {required: true, validator: cardNumValidator, trigger: 'blur'}
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			// 同身份证患者列表
			list2: {
				multipleSelection: undefined,
				data: null
			},
			filter: {
				name: '',
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				name: '',
				cardNum: '',
				patientId: 0,
			},
		}
	},
	created() {
		let query = this.$route.query;
		if (query?.name) {
			this.filter.name = query.name;
		}
		this.loadList();
		// this.form.cardNum = '370122194404264412';
		// 370122194404264412
		// 患者id：2，身份证：370122194001284419
	},
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getNoIdentityList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
				})
				this.list.data = res.data;
			}
			this.isLoading = false;
		},
		showDlg(item) {
			this.dlg.active = true;
			if (item && item.id > 0) {
				this.$nextTick(()=>{
					this.$refs['form'].resetFields();
					this.form.patientId = item.id;
					this.form.name = item.name;
				});
			} else {
				this.form.patientId = 0;
				this.$nextTick(()=>{
					this.$refs['form'].resetFields();
				});
			}
			
			console.log(this.list2)
		},
		closeDlg() {
			this.dlg.active = false;
			this.dlg.active2 = false;
		},
		onPatientSelection(selected) {
			let selection = []
			selected.forEach((item)=>{
				selection.push(item.id);
			})
			this.list2.multipleSelection = selection;
		},		
		async saveForm1() {
			let res;
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					res = await api.editNoIdentityCardNum(this.form);
					if (res.code == 1007) {
						this.dlg.active = false;
						this.dlg.active2 = true;
						if (res.data) {
							res.data.unshift({id: this.form.patientId, name: this.form.name, cardNum: this.form.cardNum,});
							this.list2.data = res.data;
						}
						return;
					} else if (res.code != 1000) {
						this.$message.error(res.message);
						return;
					}
					this.loadList();
					this.$message({message: '补录成功',type: 'success'});
					this.closeDlg();
				}
			});
			// this.dlg.active2 = true;
			// 延迟，才不会闪得那么明显
			// setTimeout(()=>{
			// 	this.dlg.active = false;
			// }, 500);
			
		},
		async saveForm2() {			
			let res = await api.mergeNoIdentityCardNum({cardNum: this.form.cardNum, patientId: this.form.patientId});
			if (res.code != 1000) {
				this.$message.error(res.message);
				return;
			}
			this.loadList();
			this.$message({message: '合并成功',type: 'success'});
			this.closeDlg();
		},
		async delItem(item) {
			let res;
			if (this.isLoading) { return;}
			
			this.isLoading = true;
			if (item && item.id > 0) {
				res = await api.delPatientGroup({groupingIds: item.id});
			} else {
				// 批量删除
				if (this.multipleSelection.length == 0) {
					this.isLoading = false;
					return this.$message.warning('未选择任何数据');
				}
				res = await api.delPatientGroup({groupingIds: this.multipleSelection.join(',')});
			}
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({message: '已删除',type: 'success'});
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			this.filter.pageNumber = 1;
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		tableRowClassName({row, rowIndex}){
			//高亮重复患者
			if (rowIndex != 0) {
				return 'warning-row';
			} else{
				return '';
			}
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
/deep/ .el-table .warning-row {
	background: #fef0f0;
	color: #f56c6c
}
</style>
